import React from 'react';

import { Control, useController } from 'react-hook-form';

import classes from './VegetableTabs.module.scss';
import { IngredientDetailsFormValues } from '../../../interfaces/IngredientDetailsFormValues';
import { LbTabs, LbToggleTabsList } from '../../../../../../shared/components/tabs';

const VEGETABLE_TAB = { YES: 'YES', NO: 'NO' } as const;

const vegetableTabs = [
  { value: VEGETABLE_TAB.YES, label: 'Yes' },
  { value: VEGETABLE_TAB.NO, label: 'No' },
];

type VegetableTabsProps = {
  control: Control<IngredientDetailsFormValues>;
};

const VegetableTabs = ({ control }: VegetableTabsProps) => {
  const {
    field: { value, onChange },
  } = useController({ control, name: 'isVegetable' });

  return (
    <div className={classes.vegetableQuestionContainer}>
      <span className={classes.vegetableQuestion}>
        Is this ingredient type a vegetable?
      </span>
      <LbTabs
        value={value ? VEGETABLE_TAB.YES : VEGETABLE_TAB.NO}
        onValueChange={(newValue) => onChange(newValue === VEGETABLE_TAB.YES)}
        data-test-id="ingredient-vegetable-tabs"
      >
        <LbToggleTabsList fullWidth tabsConfig={vegetableTabs} size="small" />
      </LbTabs>
    </div>
  );
};

export { VegetableTabs };
